module.exports = __webpack_public_path__ + "img/pc2.49529ff8.png";